import RestoreLogo from '../images/RESTORE-Logo.png';
import TimoccoLogo from '../images/timocco-resources/Timocco-Logo.png';

export const whiteLabelBrand =
  typeof import.meta.env.VITE_WHITE_LABEL_BRAND !== 'undefined' ? import.meta.env.VITE_WHITE_LABEL_BRAND : 'restore';

export const labels = {
  restore: {
    logo: RestoreLogo,
    appTitle: 'RESTORE Skills',
    faveIcon: '/favicon.ico',
    playScreen: {
      version: 'multiplayer',
      title: 'On Demand',
      singleGame: 'Single Game',
      groupPlay: 'Group Play',
      quickSession: 'Quick Session',
      designedSession: 'Designed Session',
    },
    gameSession: {
      displayDesignSession: true,
    },
    gameSessionCard: {
      outOffGymToggleLabel: 'More Restore',
    },
    playerDashboardButtons: {
      daylyProgressDislpay: true,
    },
    homePlayBulletSection: {
      bullets: [
        'Achieve and maintain your best ability to function',
        'Minimize your risk for hospitalization',
        "Have fun - exercise doesn't have to feel like a chore",
      ],
    },
    quickPlayScreen: {
      pageTitle: 'Functional Skills',
      heading: 'What skills are we restoring today?',
    },
    platform: {
      platform_id: 1,
    },
    sessionDesigner: {
      reviewSave: {
        shareLabel: 'Share with Care Partners:',
        shareToggle: 'More Restore',
        shareTooltip: 'Allows Care Partners to access and play this session with the selected player.',
      },
    },
  },
  timocco: {
    logo: TimoccoLogo,
    faveIcon: '/timocco_favicon.png',
    appTitle: 'Timocco',
    playScreen: {
      version: 'timocco',
      title: 'How would you like to play today?',
      singleGame: 'Play a Game',
      groupPlay: 'Play Together',
      quickSession: 'Premade Sessions',
      designedSession: 'Custom Session',
    },
    gameSession: {
      displayDesignSession: false,
    },
    gameSessionCard: {
      outOffGymToggleLabel: 'Teacher Access',
    },
    playerDashboardButtons: {
      daylyProgressDislpay: false,
    },
    homePlayBulletSection: {
      bullets: [
        'Improve and maintain skills',
        'Get more repetitions',
        "It's fun! Kids won't even know they are working",
      ],
    },
    quickPlayScreen: {
      pageTitle: 'Premade Sessions',
      heading: 'What skills are we parcticing today?',
    },
    platform: {
      platform_id: 2,
    },
    sessionDesigner: {
      reviewSave: {
        shareLabel: 'Share with Teacher(s):',
        shareToggle: 'Teacher Access',
        shareTooltip: 'Allows teacher(s) to access and play this session with the selected player.',
      },
    },
  },
};
